import { BRAND } from "../brand";
/** Raporlar, içe/dışa aktarım ve denetim kaydı metinleri. */
export const data = {
  /** Sütun başlıkları: şablon, dışa aktarım ve hata raporunda aynı adlar kullanılır (dışa aktar → düzelt → içe aktar). */
  columns: {
    employeeNumber: "Sicil No",
    firstName: "Ad",
    lastName: "Soyad",
    fullName: "Ad Soyad",
    workEmail: "İş E-postası",
    personalEmail: "Kişisel E-posta",
    workPhone: "İş Telefonu",
    personalPhone: "Cep Telefonu",
    startDate: "İşe Giriş Tarihi",
    seniorityStartDate: "Kıdem Başlangıcı",
    endDate: "Ayrılış Tarihi",
    department: "Birim",
    branch: "Şube",
    position: "Pozisyon",
    managerNumber: "Yönetici Sicil No",
    managerName: "Yönetici",
    nationalId: "TC Kimlik No",
    iban: "IBAN",
    birthDate: "Doğum Tarihi",
    employmentType: "Çalışma Şekli",
    status: "Durum",
    address: "Adres",
    emergencyContactName: "Acil Durumda Aranacak Kişi",
    emergencyContactPhone: "Acil Durum Telefonu",
    days: "Kalan Gün",
    effectiveDate: "Geçerlilik Tarihi",
    note: "Açıklama",
    leaveType: "İzin Türü",
    unit: "Birim (gün/saat)",
    amount: "Miktar",
    requests: "Talep Sayısı",
    balance: "Bakiye",
    pending: "Onay Bekleyen",
    available: "Kullanılabilir",
    headcount: "Aktif Kadro",
    preboarding: "Başlayacak",
    offboarding: "Ayrılış Sürecinde",
    share: "Pay (%)",
    group: "Grup",
    month: "Ay",
    hires: "İşe Giriş",
    exits: "Ayrılış",
    headcountStart: "Ay Başı Kadro",
    headcountEnd: "Ay Sonu Kadro",
    averageHeadcount: "Ortalama Kadro",
    turnoverRate: "Devir Oranı (%)",
    employees: "Çalışan Sayısı",
    unusedDays: "Kullanılmamış Gün",
    averageDays: "Kişi Başı Ortalama",
    maxDays: "En Yüksek",
    overThreshold: "Eşik Üstü Kişi",
  },
  hints: {
    employeeNumber: "Zorunlu. Her çalışana özgü numara. Sistemde varsa kayıt güncellenir, yoksa yeni çalışan eklenir.",
    firstName: "Zorunlu (yeni çalışan için).",
    lastName: "Zorunlu (yeni çalışan için).",
    workEmail: "Örn. ayse.yilmaz@sirket.com. Davet bu adrese gönderilir.",
    startDate: "Yeni çalışan için zorunlu. GG.AA.YYYY (15.03.2024) veya YYYY-AA-GG.",
    seniorityStartDate: "İsteğe bağlı. Önceki hizmet sayılıyorsa kıdemin başladığı tarih.",
    department: "Birimin sistemdeki adı. Yoksa “eksikleri oluştur” seçeneğiyle eklenebilir.",
    branch: "Şubenin sistemdeki adı.",
    position: "Pozisyon/unvan adı.",
    managerNumber: "Yöneticinin sicil no'su. Yönetici aynı dosyada da olabilir.",
    employmentType: "Tam zamanlı, Yarı zamanlı, Stajyer veya Belirli süreli. Boşsa Tam zamanlı.",
    nationalId: "11 haneli TC kimlik no. Şifreli saklanır.",
    iban: "TR ile başlayan 26 karakter; boşluklar önemli değil. Şifreli saklanır.",
    birthDate: "GG.AA.YYYY veya YYYY-AA-GG.",
    personalPhone: "Örn. 0532 123 45 67.",
    workPhone: "Örn. 0212 123 45 67.",
    personalEmail: "İş e-postası olmayan çalışanlar için.",
    days: "Zorunlu. Geçerlilik tarihindeki kalan yıllık izin günü; ör. 12 veya 12,5.",
    effectiveDate: "Zorunlu. Bakiyenin hangi tarih itibarıyla geçerli olduğu.",
    fullName: "İsteğe bağlı. Yalnızca kontrol için: sicil no ile eşleşen kişinin adı tutmazsa uyarı verilir.",
    note: "İsteğe bağlı açıklama.",
  },
  employmentTypes: {
    full_time: "Tam zamanlı",
    part_time: "Yarı zamanlı",
    intern: "Stajyer",
    fixed_term: "Belirli süreli",
  },
  statuses: {
    preboarding: "Başlayacak",
    active: "Aktif",
    offboarding: "Ayrılış sürecinde",
    terminated: "Ayrıldı",
  },
  units: { day: "gün", hour: "saat" },
  noDepartment: "Birimi atanmamış",
  noBranch: "Şubesi atanmamış",
  import: {
    sheets: {
      employees: "Çalışanlar",
      leaveBalances: "İzin Bakiyeleri",
      help: "Açıklamalar",
    },
    help: {
      column: "Sütun",
      required: "Zorunlu mu?",
      format: "Biçim ve açıklama",
      example: "Örnek",
      yes: "Evet",
      no: "Hayır",
      newOnly: "Yeni çalışan için",
      rulesTitle: "Kurallar",
      rule1: "Sicil no sistemde varsa çalışan güncellenir, yoksa yeni çalışan eklenir. Aynı dosyayı iki kez yüklemek mükerrer kayıt oluşturmaz.",
      rule2: "Güncellemede boş bırakılan hücreler mevcut değeri değiştirmez.",
      rule3: "Tarihler GG.AA.YYYY (15.03.2024) veya YYYY-AA-GG (2024-03-15) biçiminde olabilir.",
      rule4: "Dosya önce kontrol edilir; hiçbir şey kaydedilmeden satır satır sonuç gösterilir. Onayladığınızda tümü tek seferde kaydedilir.",
      rule5: "CSV kaydediyorsanız Excel'de “CSV UTF-8 (virgülle ayrılmış)” seçeneğini kullanın; noktalı virgül ayracı da kabul edilir.",
      rule6: "“#” ile başlayan satırlar açıklama sayılır ve aktarılmaz.",
      balanceRule1: "Her çalışan için bir açılış bakiyesi girilir. Sonraki değişiklikler izin bakiyesi ekranından düzeltme kaydıyla yapılır.",
      balanceRule2: "Eksi bakiye girilebilir (çalışan hak ettiğinden fazla kullandıysa).",
      csvHintPrefix: "# Açıklama satırı (silebilirsiniz):",
    },
    errors: {
      required: "{column} boş olamaz.",
      invalid_date: "Tarih anlaşılamadı. GG.AA.YYYY (15.03.2024) veya YYYY-AA-GG biçiminde yazın.",
      date_in_future: "{column} gelecekte olamaz; tarihi kontrol edin.",
      birth_after_start: "Doğum tarihi işe giriş tarihinden önce olmalı.",
      national_id_format: "TC kimlik no 11 haneli olmalı ve 0 ile başlamamalı.",
      national_id_checksum: "TC kimlik no doğrulanamadı; rakamları kimlik kartından kontrol edin.",
      national_id_taken: "Bu TC kimlik no başka bir çalışan kaydında kayıtlı; satırı kontrol edin.",
      national_id_duplicate_in_file: "Bu TC kimlik no dosyada {first}. satırda da var.",
      iban_format: "IBAN TR ile başlamalı ve 26 karakter olmalı (boşluklar önemli değil).",
      iban_checksum: "IBAN'ın kontrol haneleri tutmuyor; IBAN'ı bankadan yeniden kopyalayın.",
      invalid_email: "E-posta adresi geçersiz; ad@sirket.com biçiminde yazın.",
      invalid_phone: "Telefon numarası anlaşılamadı; ör. 0532 123 45 67 yazın.",
      too_long: "{column} en fazla {max} karakter olabilir.",
      invalid: "{column} geçersiz; şablondaki açıklamaya göre düzeltin.",
      duplicate_in_file: "Bu sicil no dosyada {first}. satırda da var; her çalışan bir kez yer almalı.",
      employee_number_taken: "Bu sicil no başka bir çalışanda kayıtlı.",
      department_not_found: "“{value}” adlı birim yok. Organizasyon ayarlarından ekleyin ya da “eksikleri oluştur” seçeneğiyle tekrar deneyin.",
      branch_not_found: "“{value}” adlı şube yok. Organizasyon ayarlarından ekleyin ya da “eksikleri oluştur” seçeneğiyle tekrar deneyin.",
      position_not_found: "“{value}” adlı pozisyon yok. Organizasyon ayarlarından ekleyin ya da “eksikleri oluştur” seçeneğiyle tekrar deneyin.",
      manager_not_found: "{value} sicil no'lu yönetici bulunamadı. Yöneticiyi dosyaya ekleyin ya da sicil no'yu düzeltin.",
      manager_self: "Çalışan kendi yöneticisi olamaz.",
      manager_terminated: "{value} sicil no'lu yönetici ayrılmış; güncel yöneticiyi yazın.",
      manager_cycle: "Yönetici zincirinde döngü var ({chain}). Bir kişi kendi astına bağlanamaz.",
      manager_row_invalid: "Yöneticinin satırında ({first}. satır) hata var; önce o satırı düzeltin.",
      employment_type_invalid: "Çalışma şekli şunlardan biri olmalı: Tam zamanlı, Yarı zamanlı, Stajyer, Belirli süreli.",
      employee_not_found: "Bu sicil no ile çalışan yok. Önce çalışanları içe aktarın ya da sicil no'yu düzeltin.",
      invalid_number: "Gün sayısı anlaşılamadı; ör. 12 veya 12,5 yazın.",
      amount_out_of_range: "Gün sayısı -365 ile 365 arasında olmalı.",
      opening_exists: "Bu çalışanın açılış bakiyesi zaten girilmiş ({date}). Değişiklik için izin bakiyesi ekranından düzeltme kaydı girin.",
      /* Dosya geneli */
      missing_column: "“{column}” sütunu bulunamadı. Şablondaki başlıkları kullanın.",
      duplicate_column: "“{column}” sütunu birden fazla kez var; birini silin.",
      no_header: "Başlık satırı bulunamadı. İlk satırda şablondaki sütun adları olmalı.",
      empty_file: "Dosyada aktarılacak satır yok.",
      too_many_rows: "Bir dosyada en fazla {max} satır olabilir; dosyayı bölüp ayrı ayrı yükleyin.",
      encoding_unknown: "Dosyanın karakter kodlaması anlaşılamadı. Excel'de “CSV UTF-8” olarak kaydedin ya da .xlsx yükleyin.",
      unreadable: "Dosya okunamadı. Excel'de .xlsx ya da “CSV UTF-8” olarak yeniden kaydedip yükleyin.",
      csv_unterminated_quote: "CSV dosyasında kapanmamış bir tırnak (\") var; {row}. satırdan sonrasını kontrol edin.",
      file_too_complex: "Dosya çok büyük ya da karmaşık. Gereksiz sayfaları silip yeniden kaydedin.",
      no_leave_type: "Bakiyesi izlenen bir yıllık izin türü yok. Önce izin türlerini ayarlayın.",
      already_imported: "Bu dosya {date} tarihinde zaten içe aktarıldı. Değişiklik yaptıysanız dosyayı yeniden kaydedip yükleyin.",
    },
    warnings: {
      unknown_column: "“{column}” sütunu tanınmadı ve aktarılmayacak.",
      encoding_1254: "Dosya Türkçe Windows kodlamasıyla (Windows-1254) okundu. Önizlemede isimlerdeki Türkçe karakterleri kontrol edin.",
      email_duplicate: "Bu e-posta adresi başka bir çalışanda da kayıtlı; davetler karışabilir.",
      name_mismatch: "Satırdaki ad, bu sicil no'lu çalışanın adıyla ({name}) eşleşmiyor; satırların kaymadığından emin olun.",
      zero_amount: "Kalan gün 0; bu satır için kayıt yazılmayacak.",
      employee_terminated: "Bu çalışan ayrılmış görünüyor.",
      not_updated: "Çalışan sistemde var ve “mevcutları güncelle” seçeneği kapalı; satır atlanacak.",
    },
    report: {
      row: "Satır",
      key: "Sicil No",
      column: "Sütun",
      severity: "Tür",
      code: "Kod",
      message: "Açıklama",
      error: "Hata",
      warning: "Uyarı",
      fileName: "ice-aktarim-hatalari",
    },
    defaultNote: "Açılış bakiyesi (içe aktarım)",
    fileNames: { employees: "calisan-sablonu", leaveBalances: "izin-bakiyesi-sablonu" },
  },
  export: {
    fileNames: {
      employees: "çalışanlar",
      leaveUsage: "izin-kullanımı",
      leaveBalances: "izin-bakiyeleri",
      headcount: "kadro",
      turnover: "giriş-çıkış",
      leaveLiability: "kullanılmamış-izin",
      leaveMonth: "izin-bordro-girdisi",
      audit: "denetim-kaydı",
    },
    sheets: {
      employees: "Çalışanlar",
      leaveUsage: "İzin Kullanımı",
      leaveBalances: "İzin Bakiyeleri",
      byDepartment: "Birim Bazında",
      byBranch: "Şube Bazında",
      turnover: "Giriş-Çıkış",
      leaveLiability: "Kullanılmamış İzin",
      leaveMonth: "Bordro Girdisi (İzin)",
      audit: "Denetim Kaydı",
    },
    total: "Toplam",
  },
  audit: {
    columns: {
      at: "Zaman",
      actor: "İşlemi Yapan",
      action: "İşlem",
      actionCode: "İşlem Kodu",
      entityType: "Kayıt Türü",
      entityId: "Kayıt Kimliği",
      employee: "Çalışan",
      effectiveDate: "Geçerlilik Tarihi",
      changes: "Değişiklikler",
      meta: "Ek Bilgi",
    },
    system: "Sistem",
    masked: "•••",
    actions: {
      employee: {
        created: "Çalışan kaydı oluşturuldu",
        updated: "Çalışan kaydı güncellendi",
        self_updated: "Çalışan kendi bilgilerini güncelledi",
        offboarding_started: "İşten çıkış süreci başlatıldı",
        offboarding_cancelled: "İşten çıkış süreci iptal edildi",
        terminated: "Çalışanın çıkışı tamamlandı",
      },
      leave: {
        submitted: "İzin talebi gönderildi",
        submitted_on_behalf: "İzin talebi çalışan adına girildi",
        edited: "İzin talebi düzenlendi",
        resubmitted: "İzin talebi düzeltilip yeniden gönderildi",
        accrued: "Yıllık izin hak edişi yazıldı",
        approved: "İzin talebi onaylandı",
        step_approved: "İzin onay adımı onaylandı",
        rejected: "İzin talebi reddedildi",
        returned: "İzin talebi düzeltmeye gönderildi",
        cancelled: "İzin talebi iptal edildi",
        corrected: "İzin talebi düzeltildi",
        rerouted: "Onay adımı başka onaycıya taşındı",
        balance_adjusted: "İzin bakiyesi düzeltildi",
        record_acknowledged: "Yıllık izin kaydı onaylandı",
      },
      import: {
        previewed: "İçe aktarım dosyası kontrol edildi",
        committed: "İçe aktarım tamamlandı",
      },
      export: {
        employees: "Çalışan listesi dışa aktarıldı",
        leave_usage: "İzin kullanım raporu dışa aktarıldı",
        leave_balances: "İzin bakiye raporu dışa aktarıldı",
        headcount: "Kadro raporu dışa aktarıldı",
        turnover: "Giriş-çıkış raporu dışa aktarıldı",
        leave_liability: "Kullanılmamış izin raporu dışa aktarıldı",
        leave_month_summary: "İzin bordro girdisi dışa aktarıldı",
      },
      audit: { exported: "Denetim kaydı dışa aktarıldı" },
      file: { accessed: "Gizli belge görüntülendi" },
      department: { created: "Birim oluşturuldu", updated: "Birim güncellendi" },
      branch: { created: "Şube oluşturuldu", updated: "Şube güncellendi" },
      position: { created: "Pozisyon oluşturuldu", updated: "Pozisyon güncellendi" },
      settings: { updated: "Şirket ayarları güncellendi" },
      leave_type: { created: "İzin türü oluşturuldu", updated: "İzin türü güncellendi" },
      delegation: { created: "Onay vekâleti verildi", revoked: "Onay vekâleti kaldırıldı" },
      holiday: { saved: "Tatil günü kaydedildi", deleted: "Tatil günü silindi" },
      work_schedule: { created: "Çalışma takvimi oluşturuldu", updated: "Çalışma takvimi güncellendi" },
      invitation: { created: "Davet gönderildi", accepted: "Davet kabul edildi", revoked: "Davet geri alındı" },
      membership: { roles_changed: "Kullanıcı rolleri değiştirildi", active: "Kullanıcı hesabı etkinleştirildi", disabled: "Kullanıcı hesabı kapatıldı" },
      user: { password_changed: "Parola değiştirildi", reset_code_created: "Parola sıfırlama kodu üretildi" },
      auth: {
        login: "Giriş yaptı",
        logout: "Çıkış yaptı",
        login_failed: "Başarısız giriş denemesi",
        locked: "Hesap kilitlendi",
      },
      tenant: {
        created: "Şirket hesabı oluşturuldu",
        suspended: "Şirket hesabı askıya alındı",
        reactivated: "Şirket hesabı yeniden açıldı",
        support_access_changed: `${BRAND.name} destek erişimi değiştirildi`,
      },
      support: {
        session_started: `${BRAND.name} destek oturumu başlatıldı`,
        session_ended: `${BRAND.name} destek oturumu bitirildi`,
        request: "Destek oturumunda istek",
      },
      platform: {
        login: "Yönetim paneline giriş",
        login_failed: "Yönetim paneline başarısız giriş",
        logout: "Yönetim panelinden çıkış",
        reauth_failed: "Parola tekrarı başarısız",
        user_searched: "Kişi arandı",
        admin_created: "Platform yöneticisi oluşturuldu",
        password_set: "Platform yöneticisinin parolası belirlendi",
        admin_disabled: "Platform yöneticisi devre dışı bırakıldı",
        admin_enabled: "Platform yöneticisi etkinleştirildi",
        sessions_revoked: "Platform yöneticisinin oturumları kapatıldı",
        totp_enabled: "Platform yöneticisinin iki adımlı doğrulaması açıldı",
        totp_disabled: "Platform yöneticisinin iki adımlı doğrulaması kapatıldı",
      },
      job: { retried: "Arka plan işi yeniden denendi" },
      advance: {
        submitted: "Avans talebi gönderildi",
        step_approved: "Avans onay adımı onaylandı",
        approved: "Avans talebi onaylandı",
        rejected: "Avans talebi reddedildi",
        cancelled: "Avans talebi geri çekildi",
        paid: "Avans ödendi",
        settled: "Avans kapatıldı",
        manager_step_skipped: "Avansta yönetici onayı atlandı (yönetici tanımlı değil)",
      },
      announcement: {
        created: "Duyuru taslağı oluşturuldu",
        updated: "Duyuru güncellendi",
        published: "Duyuru yayımlandı",
        archived: "Duyuru arşivlendi",
        acknowledged: "Duyuru okundu olarak onaylandı",
      },
      asset: {
        created: "Demirbaş eklendi",
        updated: "Demirbaş güncellendi",
        archived: "Demirbaş kullanım dışı bırakıldı",
        assigned: "Zimmet verildi",
        acknowledged: "Zimmet teslim alındı",
        returned: "Zimmet iade alındı",
      },
      checklist: {
        started: "Süreç başlatıldı",
        tasks_added: "Sürece görev eklendi",
        completed: "Süreç tamamlandı",
        cancelled: "Süreç iptal edildi",
      },
      checklist_task: {
        completed: "Görev tamamlandı",
        auto_completed: "Görev kendiliğinden tamamlandı",
        skipped: "Görev atlandı",
        reopened: "Görev yeniden açıldı",
        reassigned: "Görev başka kişiye verildi",
        released: "Görev havuza bırakıldı",
      },
      checklist_template: {
        created: "Süreç şablonu oluşturuldu",
        updated: "Süreç şablonu güncellendi",
        archived: "Süreç şablonu arşivlendi",
      },
      document: {
        uploaded: "Belge yüklendi",
        accepted: "Belge kabul edildi",
        rejected: "Belge reddedildi",
        archived: "Belge arşivlendi",
      },
      document_request: {
        created: "Belge istendi",
        fulfilled: "İstenen belge teslim edildi",
        reopened: "Belge talebi yeniden açıldı",
        cancelled: "Belge talebi iptal edildi",
      },
      expense: {
        created: "Masraf formu oluşturuldu",
        updated: "Masraf formu güncellendi",
        item_added: "Masraf kalemi eklendi",
        item_updated: "Masraf kalemi güncellendi",
        item_removed: "Masraf kalemi silindi",
        draft_deleted: "Masraf taslağı silindi",
        submitted: "Masraf formu onaya gönderildi",
        resubmitted: "Masraf formu düzeltilip yeniden gönderildi",
        step_approved: "Masraf onay adımı onaylandı",
        approved: "Masraf onaylandı",
        rejected: "Masraf reddedildi",
        returned: "Masraf düzeltmeye gönderildi",
        manager_step_skipped: "Masrafta yönetici onayı atlandı (yönetici tanımlı değil)",
        cancelled: "Masraf formu geri çekildi",
        paid: "Masraf ödendi",
      },
      expense_category: {
        created: "Masraf kategorisi eklendi",
        updated: "Masraf kategorisi güncellendi",
        archived: "Masraf kategorisi arşivlendi",
      },
      knowledge: {
        created: "Bilgi bankası makalesi eklendi",
        updated: "Bilgi bankası makalesi güncellendi",
        deleted: "Bilgi bankası makalesi silindi",
      },
      payslip: {
        attached: "Bordro pusulası yüklendi",
        matched: "Bordro pusulası çalışanla eşleştirildi",
        replaced: "Bordro pusulası değiştirildi",
        removed: "Bordro pusulası çıkarıldı",
        acknowledged: "Bordro pusulası teslim alındı",
      },
      payslip_batch: {
        created: "Bordro dağıtımı oluşturuldu",
        published: "Bordro dağıtımı yayımlandı",
      },
      push_device: {
        registered: "Bildirim cihazı kaydedildi",
        reassigned: "Bildirim cihazı başka hesaba geçti",
        removed: "Bildirim cihazı kaldırıldı",
      },
      document_type: {
        created: "Belge türü oluşturuldu",
        updated: "Belge türü güncellendi",
        archived: "Belge türü arşivlendi",
      },
    },
  },
};
